import { render, staticRenderFns } from "./HeaderDashboard.vue?vue&type=template&id=ed6df354&"
import script from "./HeaderDashboard.vue?vue&type=script&lang=js&"
export * from "./HeaderDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports